import React from 'react';
import { Container } from 'reactstrap';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const { REACT_APP_ROOT_URL } = process.env;

const Footer = () => (
  <Container className="footer">
    <hr />
    <div className="py-3">
      <Trans i18nKey="COMMON.FOOTER">
        <p className="mb-1">Powered by Trooper Webshops</p>
        <a
          href={REACT_APP_ROOT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Try it for free
        </a>
      </Trans>
      {' '}
      <FontAwesomeIcon icon={faChevronRight} size="sm" className="text-primary" />
    </div>
  </Container>
);

export default Footer;
